// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://multisabores.nbg1.your-objectstorage.com/public';
const server = "https://apimultisabores.mansolutions.app";
const port = 443;
const domain = "multisabores.mansolutions.app";
export { server, port, domain, serverImg };
